import React, { useEffect } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../Infrastructure/config"
import { useLocation, useNavigate } from "react-router-dom";
import { USER_LOGS_CLIENT } from "../../../Infrastructure/Constants/logsConstant";
import { ErrorCode, ErrorContainer, ErrorMessage, HomeButton } from "./style";
import useAuthentication from "../../../Infrastructure/States/onAuthStateChange";
import { useSelector } from "react-redux";
import paths from "../../../Infrastructure/Router/paths";
import { safeClientLogEvent } from "../../../Infrastructure/Utilities/safeClientLogEvent";

const Error404 = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const {userId} = useAuthentication()
  const ip = useSelector((state) => state.ip.address)
  const page = useSelector((state) => state.route.currentRoute)
  const path = `${window.location.origin}${location.pathname}${location.search}${location.hash}`

  useEffect(() => {
    const logUserRoute = async () => {
      try {
        const pageNotFoundLogger = httpsCallable(functions, "pageNotfoundlogger")
        await pageNotFoundLogger({ route: path, page, ip })
      } catch (error) {
        await safeClientLogEvent({
          ...USER_LOGS_CLIENT.PAGE_NOTE_FOUND_ERROR,
          uid: userId || null,
          source: "error404.jsx",
          emailInfo: null,
          metadata: null,
          error: error?.message || null
        });
      }
    }
    logUserRoute()
    // eslint-disable-next-line
  }, [])
  return (
    <>
      <ErrorContainer>
        <ErrorCode variant="h1" color={'primary'}>404</ErrorCode>
        <ErrorMessage variant="body1">
          Oops! The page you're looking for does not exist.
        </ErrorMessage>
        <HomeButton variant="contained" onClick={() => navigate(paths.home.path)}>
          Go to Home
        </HomeButton>
      </ErrorContainer>
    </>
  );
};

export default Error404;
